<template>
  <!-- Kontener filtru naruszeń wyświetlany tylko, gdy istnieje wybrane naruszenie -->
  <div v-if="isChoosen()" class="filter d-flex flex-column">
    <!-- Nagłówek sekcji z tytułem i ikoną usuwania wszystkich filtrów -->
    <h5 class="margin-0">
      {{ t('violations') }}
      <!-- Ikona kosza: usuwa wszystkie zaznaczone naruszenia -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!-- Iteracja po wszystkich dostępnych naruszeniach z store.
         `v-if` musi siedzieć na wrapperze `.collapse`, a nie w jego środku:
         inaczej niezaznaczone naruszenia zostawiają puste divy, które mimo
         zerowej wysokości wnoszą `margin: 3px 0` i tworzą martwy pas pod listą.
         Warunek jest w `<template v-for>`, bo w Vue 3 `v-if` na tym samym
         elemencie co `v-for` ma wyższy priorytet i nie widziałby `name`. -->
    <template v-for="(violation, name) in store.violations" :key="name">
      <div v-if="store.filters[name]" class="collapse show" id="violations">
        <div class="info d-flex">

          <!-- Checkbox reprezentujący pojedyncze naruszenie -->
          <input-checkbox
            :field-name="name"
            field-value=""
            :checkedCondition="true"
            @clicked="setFilter(name)"
            vio="vio"
          />

          <!-- Etykieta z nazwą naruszenia (tłumaczona) -->
          <p class="m-0">{{ violation }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// Import komponentu input-checkbox do zaznaczania/odznaczania naruszeń
import InputCheckbox from "../InputCheckbox.vue";

export default {
  name: "ViolationFilterView",  // Nazwa komponentu

  props: {
    // Store zawierający filtry i dane o naruszeniach
    store: { required: true },
  },

  components: { InputCheckbox }, // Rejestracja komponentu checkbox

  methods: {
    /**
     * Sprawdza, czy którykolwiek filtr naruszeń jest wybrany
     * @returns {boolean}
     */
    isChoosen() {
      const filters = this.store.filters;
      return Object.keys(this.store.violations).some(key => filters[key] === true);
    },

    /**
     * Przełącza stan filtra danego naruszenia:
     * - jeśli jest zaznaczone, odznacza (ustawia false)
     * - jeśli nie jest, zaznacza (ustawia true)
     * @param {string} id - klucz filtra (nazwa naruszenia)
     */
    setFilter(id) {
      const value = this.store.filters[id] ? false : true;
      this.store.addItem(id, value);
    },

    /**
     * Usuwa wszystkie filtry naruszeń z store
     */
    removeFilter() {
      this.store.removeItem("violations");
    },
  },
};
</script>

<style scoped>
/* Ustawienia kontenera filtra */
.filter {
  width: 100%;
}

/* Styl nagłówka z białym tłem i ikoną */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Styl elementów collapse (pojedynczych wierszy) */
.filter .collapse {
  margin: 3px 0;
}

/* Styl wiersza info z checkboxem i etykietą */
.info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 10px;
  padding-left: 27px;
  font-size: var(--font-size-sm);
}

/* Styl ikony kosza */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}
</style>